// src/components/KYB/IdentityVerfication/DocumentUploadSection.tsx
// @ts-nocheck
import React, { memo, useEffect, useMemo } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import CustomSelectField from '../../commonComponents/CommonSelect';
import { textColor } from '../../../utils/commonstyle';
import uploadDone from '../../../assets/uploadGreen.png';
import trash from '../../../assets/trash.png';
import { toast } from 'react-toastify';

export interface DocumentOption {
  value: string;
  label: string;
}

export interface DocumentFile {
  name: string;
  type: string;
  size?: number;
  lastModified?: number;
}

export interface DocumentTypes {
  [key: string]: any;
}

interface DocumentUploadSectionProps {
  title: string;
  type: string;
  options: DocumentOption[];
  documentTypes: DocumentTypes;
  message: any;
  files: any;
  onSelectChange: any;
  onFileChange: any
  onRemoveFile: (type: string, index: number, typeUser: string) => void;
  additionalNote?: any;
  allowedFileTypes?: string[]; // e.g., ['.jpeg', '.png', '.pdf']
  count?: any
  typeUser?: any
}

const DEFAULT_ALLOWED_TYPES = ['.jpg', '.jpeg', '.png', '.pdf'];
const DEFAULT_MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const DocumentUploadSection: React.FC<DocumentUploadSectionProps> = ({
  title,
  type,
  options,
  documentTypes,
  message,
  files,
  onSelectChange,
  onFileChange,
  onRemoveFile,
  additionalNote,
  allowedFileTypes = DEFAULT_ALLOWED_TYPES,
  count,
  typeUser,
  details
}) => {

  const id = useMemo(() => {
    return typeUser ? type + typeUser : type
  }, [type, typeUser])

  const handleClick = () => {
    document.getElementById(id)?.click();
  };

  const handleDragOver = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
  };

  const handleDrop = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
    const uploadedFiles = Array.from(event.dataTransfer.files);
    if (uploadedFiles.length) {
      // Validate file types before processing
      const allowedFileTypes = ['.jpg', '.jpeg', '.png', '.pdf'];
      for (const file of uploadedFiles) {
        const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
        if (!allowedFileTypes.includes(fileExtension)) {
          toast.error(`File type ${fileExtension} is not allowed. Please upload only ${allowedFileTypes.join(', ')} files.`, {
            className: "custom-toast",
          });
          return;
        }
      }

      const changeEvent = {
        target: { files: uploadedFiles }
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      onFileChange(changeEvent, type);
    }
  };

  const selectedLabel = useMemo(() => {
    return options.find((ele) => ele.value === details?.DocumentType)?.label;
  }, [details?.DocumentType, options]);

  return (
    <Box mb={1}>
      <Typography my="14px">{title}</Typography>
      <CustomSelectField
        label="Govt / State issued ID"
        name={type}
        size="middle"
        options={options}
        value={documentTypes[type]}
        isDocument={true}
        onChange={(e: any, type: any, ele: any) => { onSelectChange(e, type, ele) }}
      />
      <ul style={{ marginTop: 8, paddingLeft: 20, listStyle: "disc" }}>
        {message?.split(";").map((msg, index) => (
          msg.trim() && (
            <li key={index} style={{
              marginBottom: 2,
              wordBreak: "break-word",         // break long words
              whiteSpace: "normal",            // allow wrapping
              overflowWrap: "anywhere"         // wrap even without spaces
            }}  >
              <Typography component="span" fontSize={14} display={"flex"} color="initial">
                {msg.trim()}
              </Typography>
            </li>
          )
        ))}
      </ul>

      <Box sx={{ display: "flex" }}>  <Box
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        data-testid="document-drop-zone"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && handleClick()}
        aria-label="Upload document"
        sx={{
          border: `2px dashed ${textColor.borderColor}`,
          borderRadius: "8px",
          width: "100%",
          my: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <input
          type="file"
          id={id}
          accept={allowedFileTypes.join(', ')}
          style={{ display: "none" }}
          onChange={(e) => {
            const uploadedFiles = Array.from(e.target.files || []);
            if (uploadedFiles.length) {
              // Validate file types before processing
              for (const file of uploadedFiles) {
                const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
                if (!allowedFileTypes.includes(fileExtension)) {
                  toast.error(`File type ${fileExtension} is not allowed. Please upload only ${allowedFileTypes.join(', ')} files.`, {
                    className: "custom-toast",
                  });
                  e.target.value = '';
                  return;
                }
              }
            }
            onFileChange(e, type);
          }}
          data-testid="document-upload-input"
          data-type={type}
          data-user={typeUser}
          aria-label="File upload input"
        />
        <IconButton
          data-testid="document-upload-button"
          sx={{ backgroundColor: "#F5F5F5", my: 1 }}
          aria-label="Upload document button"
        >
          <CloudUploadOutlinedIcon sx={{ color: "#FF5C39", fontSize: "24px" }} />
        </IconButton>
        <Typography fontSize={16} my={1} color={textColor.fontColor}>
          Click to upload a file or drag & drop it here.
        </Typography>
        <Typography fontSize={14} mb={3} color={textColor.fontColor}>
          {allowedFileTypes.join(', ')} Maximum 10MB.
        </Typography>
      </Box>

      </Box>
      {(typeUser ? files[typeUser][type]?.files?.length : files[type]?.files?.length > 0) ? (
        <Box>
          {(typeUser ? files[typeUser][type]?.files : files[type]?.files).map((file: any, idx: number) => (
            <Box
              key={idx}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              p={1}
              my={1}
              gap={2}
              bgcolor="#F5F5F5"
              borderRadius="4px"
            >
              <Typography
                fontSize={14}
                sx={{
                  width: {
                    xs: '66%',   // mobile
                    sm: '80%',   // tablets and up
                  },
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                }}
                color="text.secondary"
              >
                {file.name} ({(file.size / 1024).toFixed(2)} KB)
              </Typography>
              <Box sx={{ display: 'flex', fontSize: 14, alignItems: "center" }}>
                <Typography color={textColor.fontColor} fontSize={14}>Uploaded</Typography>
                <div data-testid="upload-progress" aria-label="Upload complete">
                  <img src={uploadDone} alt="upload" width={23} height={23} />
                </div>
                <IconButton
                  onClick={() => onRemoveFile(type, idx, typeUser)}
                  data-testid="remove-file-button"
                  aria-label="Remove file"
                  sx={{
                    backgroundColor: "#F5F5F5",
                    '&:hover': {
                      backgroundColor: '#e0e0e0'
                    }
                  }}
                >
                  <img src={trash} alt="remove file" width={20} height={20} />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

export default memo(DocumentUploadSection);